export default __webpack_public_path__ + "assets/images/d8b1a3e222979fbfe40dcf66bcfd20ad.svg";